import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button } from "react-bootstrap";

import RemoveClientModal from "./RemoveClientModal";

const RemoveClient = (props) => {
  const { onChange } = props;

  const [showAddClientModal, setShowAddClientModal] = useState(false);

  const onCreateClientComplete = async (client) => {
    console.log(client);
    onChange({ value: client.value, label: client.name });
  };

  return (
    <div className="flex justify-center items-center">
      <Button
        size="sm"
        variant="outline-primary"
        onClick={() => setShowAddClientModal(true)}
        className="text-xs md:text-base min-w-[150px] border-[#004b8f] hover:bg-[#004b8f] text-[#004b8f] hover:border-[#004b8f]"
      >
        Rimuovere cliente
      </Button>

      <RemoveClientModal
        show={showAddClientModal}
        handleClose={() => setShowAddClientModal(false)}
        onRemoveComplete={onCreateClientComplete}
      />
    </div>
  );
};

RemoveClient.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default RemoveClient;
